import Grid from "@mui/material/Grid";
import Section from "../components/ui/Section";
import PlanCard from "../components/ui/PlanCard";
import { PLANS } from "../content/plans";
import { headers } from "../content/meta";

export default function Pricing() {
  return (
    <Section id="pricing" header={headers.pricing}>
      <Grid container spacing={2} alignItems="stretch">
        {PLANS.map((p) => (
          <Grid key={p.key} size={{ xs: 12, md: 6, lg: 4 }}>
            <PlanCard {...p} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}
